import React, { useEffect, useRef } from "react";
import { useSequenceAlarm } from "../context/SequenceAlarmContext";

/**
 * Legacy global sequence alarm gate. Training cues now play via
 * `utils/exerciseTimerSounds.js` (iOS SoundManager parity).
 */
const SequenceAlarm = () => {
  const { isSequenceAlarmPlaying, setIsSequenceAlarmPlaying } =
    useSequenceAlarm();
  const armedRef = useRef(false);

  useEffect(() => {
    if (!isSequenceAlarmPlaying) {
      armedRef.current = false;
      return undefined;
    }
    if (armedRef.current) return undefined;
    armedRef.current = true;
    const t = setTimeout(() => setIsSequenceAlarmPlaying(false), 50);
    return () => clearTimeout(t);
  }, [isSequenceAlarmPlaying, setIsSequenceAlarmPlaying]);

  return null;
};

export default SequenceAlarm;
